export default function HeroSection() {
  return (
    <>
      {/* Hero */}
      <section className="relative w-full overflow-hidden">
        {/* Desktop */}
        <img
          src={`${__BASE_PATH__}public/img/hikakusiteMV_pc_005.png`}
          alt="オール電化の家"
          className="w-full h-auto hidden md:block"
        />
        {/* Mobile */}
        <img
          src={`${__BASE_PATH__}public/img/hikakusiteMV_mv_004.png`}
          alt="オール電化の家"
          className="w-full h-auto block md:hidden"
        />
      </section>
    </>
  );
}